import {ReactElement} from 'react';
import {css} from 'aphrodite/no-important';

import {Props} from './Props';
import styles from './styles';

const TabBar = <T extends string>({activeId, tabBarItems, onClickedOnTab}: Props<T>): ReactElement => {
    return (
        <ul className={css(styles.listItemContainer)}>
            {tabBarItems.map((item) => {
                const active = activeId === item.id;
                return (
                    <li
                        key={item.id}
                        data-test-id={`tab-bar-item-${item.id}`}
                        className={css(styles.listItem, active && styles.listItemActive)}
                        onClick={() => onClickedOnTab(item.id)}
                    >
                        <span className={css(styles.listItemContent)}>{item.name}</span>
                    </li>
                );
            })}
        </ul>
    );
};
export default TabBar;
